import { createContext, useContext } from 'react';

export type TabsContextProps<TValue> = {
    value: TValue | undefined;
    setValue: (value: TValue) => void;
    setTabList: (el: HTMLDivElement | null) => void;
    removeHiddenTabsFromDom: boolean;
};

export const TabContext = createContext<TabsContextProps<string> | null>(null);

export const useTabsContext = <TValue = string>() => useContext(TabContext) as TabsContextProps<TValue>;
